if (!customElements.get('nc-woody-collection')) {
  customElements.define('nc-woody-collection', class extends HTMLElement {
    connectedCallback() {
      this.change = (event) => {
        if (!event.target.matches('[data-nc-availability]')) return;
        const url = new URL(window.location.href);
        url.searchParams.set('nc_availability', event.target.value);
        history.pushState({ searchParams: url.searchParams.toString() }, '', url);
        this.refresh();
      };
      this.historyChange = () => this.refresh();
      this.addEventListener('change', this.change);
      window.addEventListener('popstate', this.historyChange);
      queueMicrotask(() => this.refresh());
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.change);
      window.removeEventListener('popstate', this.historyChange);
    }

    refresh() {
      const url = new URL(window.location.href);
      const legacy = url.searchParams.getAll('filter.v.availability');
      if (legacy.length) {
        url.searchParams.set('nc_availability', legacy.length > 1 ? 'all' : legacy[0] === '1' ? 'available' : 'unavailable');
        url.searchParams.delete('filter.v.availability');
        url.searchParams.delete('page');
        window.location.replace(url);
        return;
      }
      const requested = url.searchParams.get('nc_availability');
      const mode = ['all', 'available', 'unavailable'].includes(requested) ? requested : 'available';
      const cards = [...this.querySelectorAll('[data-nc-orderable]')];
      const sort = url.searchParams.get('sort_by');
      if (sort === 'price-ascending' || sort === 'price-descending') {
        const direction = sort === 'price-ascending' ? 1 : -1;
        const grid = this.querySelector('#product-grid');
        [...cards].sort((a, b) => {
          const unavailableOrder = Number(a.dataset.ncOrderable !== 'true') - Number(b.dataset.ncOrderable !== 'true');
          return unavailableOrder || direction * (Number(a.dataset.ncPrice) - Number(b.dataset.ncPrice));
        }).forEach((card) => grid.append(card));
      }
      const available = cards.filter((card) => card.dataset.ncOrderable === 'true');
      const counts = { all: cards.length, available: available.length, unavailable: cards.length - available.length };
      cards.forEach((card) => {
        card.hidden = mode !== 'all' && (card.dataset.ncOrderable === 'true') !== (mode === 'available');
      });
      this.querySelectorAll('[data-nc-availability]').forEach((input) => { input.checked = input.value === mode; });
      this.querySelectorAll('[data-nc-count]').forEach((element) => { element.textContent = counts[element.dataset.ncCount]; });
      this.querySelector('[data-nc-controls]').hidden = false;
      this.querySelector('[data-nc-empty]').hidden = counts[mode] > 0;
      const message = this.dataset.countLabel.replace('[count]', counts[mode]).replace('[total]', cards.length);
      this.querySelector('[data-nc-status]').textContent = message;
      document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach((element) => {
        element.textContent = message;
        element.dataset.productCount = counts[mode];
      });
      document.querySelectorAll('facet-filters-form form').forEach((form) => {
        let field = form.querySelector('input[name="nc_availability"]');
        if (!field) {
          field = document.createElement('input');
          field.type = 'hidden';
          field.name = 'nc_availability';
          form.append(field);
        }
        field.value = mode;
      });
    }
  });
}
